<template>
  <!--  -->
  <div v-if="open">
    <!--  -->
    <div v-if="text.isPopup">
      <!--  -->
      <vue-modal-2 name="notificationPopup" :headerOptions="{ title: `Notification` }" @on-close="closeModel()" :noFooter="true" modalSize="lg">
        <!--  -->
        <div class="bg-white rounded-lg pb-4 px-5">
          <!--  -->
          <div :class="text.rtl ? 'rtl-direction' : ''">
            <p v-html="text.text"></p>
          </div>
          <!--  -->
        </div>
        <!--  -->
      </vue-modal-2>
      <!--  -->
    </div>
    <!--  -->

    <!--  -->
    <div v-else :class="classDiv" role="alert">
      <!--  -->
      <div class="inner-cod" :class="text.rtl ? 'isrtl' : ''">
        <span v-html="text.text" class="mess-cod"></span>
      </div>
      <!--  -->

      <!--  -->
      <button class="close-button-notif close-rotate" @click="close()">
        <svg aria-hidden="true" data-icon="times" viewBox="0 0 612 612">
          <polygon  points="612,36.004 576.521,0.603 306,270.608 35.478,0.603 0,36.004 270.522,306.011 0,575.997 35.478,611.397 306,341.411 576.521,611.397 612,575.997 341.459,306.011"> </polygon>
        </svg>
      </button>
      <!--  -->
    </div>
    <!--  -->
  </div>
  <!--  -->
</template>

<script>
export default {
  props: {
    user: { type: Object },
    text: { type: Object, default() { return {} } },
    classDiv: { type: String },
    preview: { default: false, },
  },
  data() {
    return {
      open: true
    };
  },
  watch: {
    '$store.state.openNotif': async function (oldVal, newVal) {
      this.open = oldVal
    },
  },
  async mounted() {
    if (this.preview) this.open = true;
    if(this.text.isPopup) {
      this.$vm2.open('notificationPopup');
    } 
  },
  methods: {
    async closeModel() {
      this.$vm2.close('notificationPopup');
      this.close();
    },
    async close() {
      if (!this.preview) {
        this.open = false;
        this.$store.dispatch("actionNotif", { openNotif: false });
        const data = await this.$server.update("users", { _id: this.user._id, Notification: 'system' });
      }
    }
  }
};
</script>
